export const ENV_FLAG_PREFIX = "FF_";
